module.exports = __webpack_public_path__ + "img/loader.88f2e121.gif";